import { Component, Inject, Input, OnInit } from '@angular/core';
import { TaskManagerService } from 'app/modules/remote-control/services/task-manager.service';
import { TaskManagerState } from 'app/modules/remote-control/services/taskManagerState';
import { RcContext } from 'app/modules/remote-control-ng/context/rcContext';

@Component({
  selector: 'app-task-details',
  templateUrl: './task-details.component.html',
  styleUrls: ['./task-details.component.scss'],
})
export class TaskDetailsComponent implements OnInit {
  @Input()
  public deviceKind: string;
  public pid: number;
  public state: TaskManagerState;
  private defaultComponentName = 'windows';
  /** Dictionary of supported activity types with their template urls and icon css classes */
  private supportedDeviceKind: { [family: string]: { component: string } } = {
    AndroidPlus: {
      component: 'android',
    },
    AndroidForWork: {
      component: 'android',
    },
    AndroidKnox: {
      component: 'android',
    },
    AndroidElm: {
      component: 'android',
    },
    WindowsCE: {
      component: this.defaultComponentName,
    },
    WindowsDesktopLegacy: {
      component: this.defaultComponentName,
    },
  };

  constructor(
    private taskManagerService: TaskManagerService) {}

  ngOnInit() {
    this.state = this.taskManagerService.getState(RcContext.instance.sotiAssistDeviceId) as any;
  }

  /** Gets the activity type for the controller - type on activity takes precedent over activity type */
  public getDeviceKind = (): string => {
    let deviceKind = this.deviceKind;

    if (this.state) {
      deviceKind = this.state.getOs();
    }

    return deviceKind;
  };

  public getComponentName = (): string => {
    const deviceKind = this.getDeviceKind();
    let component = '';

    if (deviceKind && this.supportedDeviceKind[deviceKind]) {
      component = this.supportedDeviceKind[deviceKind].component;
    }

    if (!component) {
      component = this.defaultComponentName;
    }

    return component;
  };

  public goBack = () => {
    this.state.inDetailsView = false;
  };
}
